var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documents)?_c('list-documents-results',{attrs:{"context":_vm.context,"nbEstimateDocument":_vm.nbEstimateDocument,"nbDocuments":_vm.localAllDocuments.length,"listType":_vm.listType,"changeSort":_vm.changeSort},model:{value:(_vm.documents),callback:function ($$v) {_vm.documents=$$v},expression:"documents"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9ae9d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListDocuments/ListDocuments.vue
// module id = null
// module chunks = 